import React from 'react';
import { FaTooth, FaSmile, FaAward, FaUsers, FaClock, FaShieldAlt } from 'react-icons/fa';
import logo from '../assets/phoenix dental care.png';

const About = () => {
  const stats = [
    { icon: <FaUsers />, value: "5000+", label: "Happy Patients" },
    { icon: <FaAward />, value: "15+", label: "Years Experience" },
    { icon: <FaClock />, value: "24/7", label: "Emergency Care" },
    { icon: <FaShieldAlt />, value: "98%", label: "Success Rate" },
  ];

  return (
    <section id="about" className="relative bg-gradient-to-br from-phoenix-beige via-phoenix-white to-phoenix-beige py-20 overflow-hidden">
      {/* Background Teeth Icons */}
      <div className="absolute text-phoenix-gold opacity-10 text-4xl" style={{ top: '10%', left: '5%' }}>
        <FaTooth />
      </div>
      <div className="absolute text-phoenix-gold opacity-10 text-3xl" style={{ top: '20%', right: '8%' }}>
        <FaTooth />
      </div>
      <div className="absolute text-phoenix-gold opacity-10 text-5xl" style={{ top: '60%', left: '10%' }}>
        <FaTooth />
      </div>
      <div className="absolute text-phoenix-gold opacity-10 text-2xl" style={{ top: '70%', right: '15%' }}>
        <FaTooth />
      </div>
      <div className="absolute text-phoenix-gold opacity-10 text-3xl" style={{ top: '40%', left: '80%' }}>
        <FaTooth />
      </div>
      <div className="absolute text-phoenix-gold opacity-10 text-4xl" style={{ top: '80%', right: '5%' }}>
        <FaTooth />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-phoenix-gold rounded-full mb-4">
            <FaSmile className="text-2xl text-phoenix-white" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-phoenix-black mb-4">
            About <span className="text-phoenix-gold">Dr. Gadam</span> & Phoenix Dental
          </h2>
          <div className="w-24 h-1 bg-phoenix-gold mx-auto mb-6"></div>
          <p className="text-xl text-phoenix-gray max-w-3xl mx-auto">
            Where expertise meets compassion in creating healthy, beautiful smiles
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div className="relative">
            <div className="relative">
              <div className="absolute -top-4 -left-4 w-20 h-20 bg-phoenix-gold rounded-full opacity-20"></div>
              <div className="absolute -bottom-4 -right-4 w-16 h-16 bg-phoenix-gold rounded-full opacity-30"></div>
              <img
                src={logo}
                alt="Dr. Gadam and Phoenix Dental Clinic"
                className="relative z-10 w-full h-auto"
              />
            </div>
          </div>

          <div className="space-y-6">
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-xl border border-phoenix-gold/20">
              <h3 className="text-2xl font-bold text-phoenix-black mb-4 flex items-center">
                <FaTooth className="text-phoenix-gold mr-3" />
                Our Story
              </h3>
              <p className="text-phoenix-gray leading-relaxed mb-4">
                Dr. Gadam is a highly experienced dental professional with over 15 years of dedicated service,
                committed to providing exceptional care with advanced facilities and a truly patient-centered approach.
              </p>
              <p className="text-phoenix-gray leading-relaxed">
                At Phoenix Dental Clinic, we combine state-of-the-art technology with a warm, comfortable environment
                to ensure every patient receives the best possible dental experience.
              </p>
            </div>

            <div className="bg-gradient-to-r from-phoenix-gold/10 to-phoenix-gold/5 rounded-2xl p-6 border border-phoenix-gold/20">
              <h3 className="text-2xl font-bold text-phoenix-black mb-4 flex items-center">
                <FaAward className="text-phoenix-gold mr-3" />
                Our Commitment
              </h3>
              <p className="text-phoenix-gray leading-relaxed">
                We believe that everyone deserves a healthy, confident smile. Our team works tirelessly to provide
                personalized care that not only addresses your dental needs but also helps you feel comfortable and confident.
              </p>
            </div>
          </div>
        </div>

        {/* Stats Section */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="bg-white/90 backdrop-blur-sm rounded-xl p-6 text-center shadow-lg border border-phoenix-gold/20"
            >
              <div className="text-3xl text-phoenix-gold mb-2 flex justify-center">
                {stat.icon}
              </div>
              <div className="text-2xl font-bold text-phoenix-black mb-1">{stat.value}</div>
              <div className="text-sm text-phoenix-gray">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
